module.exports = __webpack_public_path__ + "img/language-world.eded0fb1.svg";